export const setOnWindow = (propertyName: string, property: unknown) =>
    (window[propertyName] = property);
